import TransactionHistoryTable from "./tables/TransactionHistoryTable";
import ReservedCreditsTable from "./tables/ReservedCreditsTable";

interface FilterOption {
  value: string;
  label: string;
  count?: number;
}

interface TransactionHistoryV2TableProps {
  transactionData: any[];
  isReservedTab?: boolean;
  onFilterSelect?: (filter: string) => void;
  isLoading?: boolean;
  filterOptions?: FilterOption[];
  selectedTab?: string;
}

// This component now acts as a router/orchestrator for the different table types
const TransactionHistoryV2Table = ({
  transactionData = [],
  isReservedTab = false,
  onFilterSelect,
  isLoading = false,
  filterOptions = [],
  selectedTab = "ALL"
}: TransactionHistoryV2TableProps) => {
  // Route to the appropriate table component based on tab
  if (isReservedTab) {
    return (
      <ReservedCreditsTable
        transactionData={transactionData}
        isLoading={isLoading}
      />
    );
  }

  return (
    <TransactionHistoryTable
      transactionData={transactionData}
      onFilterSelect={onFilterSelect}
      isLoading={isLoading}
      filterOptions={filterOptions}
      selectedTab={selectedTab}
    />
  );
};

export default TransactionHistoryV2Table;
